import React from 'react';
import { Message, Container, Icon } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);
const RightPanelConfirmation = (props) => {
  let deleteAllRoles = false;
  let deleteRolesText =
    props.deletedRoleIds && props.deletedRoleIds.length == 1
      ? !!props.isViewingOthers
        ? APP.LANGUAGE.MyRoles.removeOtherUserRoleConfirmSingle.replace('##selectedUserName##', props.selectedUserName)
        : APP.LANGUAGE.MyRoles.removeRoleConfirmSingle
      : !!props.isViewingOthers
      ? APP.LANGUAGE.MyRoles.removeOtherUserRoleConfirmMultiple.replace('##selectedUserName##', props.selectedUserName)
      : APP.LANGUAGE.MyRoles.removeRoleConfirmMultiple.replace('##Number##', props.deletedRoleIds.length);
  let deleteClass = 'mrtm';
  let deleteRolesExtraText = '';
  if (
    props.deletedRoleIds &&
    props.myRoles &&
    props.myRoles.length == props.deletedRoleIds.length &&
    !props.hasRolesInOtherNetworks
  ) {
    deleteAllRoles = true;
    deleteRolesText = !!props.isViewingOthers
      ? APP.LANGUAGE.MyRoles.removeAllOtherUserRoleConfirm.replace('##selectedUserName##', props.selectedUserName)
      : APP.LANGUAGE.MyRoles.removeAllRoleConfirm;
    deleteRolesExtraText = !!props.isViewingOthers
      ? APP.LANGUAGE.MyRoles.removeAllOtherUserRoleConfirmPart2.replace('##selectedUserName##', props.selectedUserName)
      : APP.LANGUAGE.MyRoles.removeAllRoleConfirmPart2;
    deleteClass = 'mrtxs';
  }
  const emptyWarning = (onMobile) => {
    let warningClass = 'borderless bg-transparent pdlnull pdrnull';
    if (onMobile) {
      warningClass = warningClass + ' color-bad-things-text-on-mobile';
    } else {
      warningClass = warningClass + ' color-bad-things-text';
    }
    return deleteAllRoles ? (
      <Message icon className={warningClass}>
        <Icon name="myrole exclamation circle" className="mrrm" />
        <Message.Content>
          <div className="">{htmlToReactParser.parse(xss(deleteRolesExtraText))}</div>
        </Message.Content>
      </Message>
    ) : (
      ''
    );
  };
  let removeBtnClasses =
    'ui labeled icon button icon left-text color-button mrbnull color-button-hover mrpcrxs color-white mrlnull max-width';
  let removeCancelClass =
    'ui cancel mrtm labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width  mrlnull mrbs mrrnull';
  return (
    <div className="">
      <div className="">
        <span>{deleteRolesText}</span>
      </div>
      <Container fluid as={Media} lessThan="computer">
        {emptyWarning(true)}
      </Container>
      <Container fluid as={Media} greaterThanOrEqual="computer">
        {emptyWarning(false)}
      </Container>
      <div className={'ui actions ' + deleteClass}>
        <button
          type="button"
          id="remove-save-btn"
          onClick={props.handleConfirmSave}
          className={props.confirmSaveClick ? removeBtnClasses + ' loading disable remove-save-btn' : removeBtnClasses}
        >
          {APP.LANGUAGE.Yes}
          <i className="checkmark icon " />
        </button>
        <button
          onClick={props.cancelConfirmUpdate}
          type="button"
          id="remove-cancel-btn"
          className={props.confirmSaveClick ? removeCancelClass + ' disable remove-save-btn' : removeCancelClass}
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.No}
        </button>
      </div>
    </div>
  );
};

export default RightPanelConfirmation;
